var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('headerComponent',{key:Math.random()}),_vm._v(" "),_c('router-view',{key:Math.random()}),_vm._v(" "),_c('footerComponent'),_vm._v(" "),_c('button',{staticClass:"back-top",attrs:{"id":"back-top"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("TOP")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560f6df7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 